export const API_URL = process.env.GATSBY_API_URL;

// eslint-disable-next-line no-console
